import React, { useEffect, useState } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import FlowBuilder from "../../pages/FlowBuilder/FlowBuilder";
import CircularProgress from "@mui/material/CircularProgress";
import {
  createClientApi,
  createEnvApi,
} from "../../apis/createEnvApi/createEnvApi";
import { useDispatch, useSelector } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Flow_builder_design from "../../assets/images/Flow_image.png";
import TextField from "@mui/material/TextField";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getFlow,
  getRNData,
  updateConfirmation,
  updateFlow,
} from "../../apis/flowBuilderApi/flowBuilderApi";
import ConfirmChangesModal from "../../components/FbKeysConfirmation/FbKeysConfirmationModal";

function ApplicationFlow() {
  const [loading, setLoading] = React.useState(false);
  const [showFlowDiv, setShowFlowDiv] = React.useState(false);
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const [appRNData, setAppRNData] = React.useState<any>([]);
  const [appFlowData, setAppFlowData] = React.useState<any>([]);
  const ActiveClient=useSelector((state:any)=>state.clientDetails.activeClient);

  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmData, setConfirmData] = useState([]);
  const [flowSubmitData, setFlowSubmitData] = useState<any>({});



  useEffect(() => {
     getAppFlow();
  }, []);
  useEffect(() => {
  }, [appFlowData]);

  const getAppFlow = ()=>{
    const payload ={
      "includeTerraformGeneratedKey": "Y"
    }
    getRNData(payload,(res: any) => {
        setAppRNData(res);
        let payload={
          "Client_Id": ActiveClient.Client_Id,
          "Env_Id":ActiveClient.Env_Data[0].Env_Id
        }
        getFlow(payload,(res:any)=>{
          if(res){
            setAppFlowData(res[0].Flow_Builder_Object);
                 //show App flow Builder
                 setLoading(false);
                 setShowFlowDiv(true);
          }
        })
      });


      
     
  }
  const getFlowByEnv = (Env_Id:number)=>{
      let payload={
        "Client_Id": ActiveClient.Client_Id,
        "Env_Id":Env_Id
      }
      getFlow(payload,(res:any)=>{
        setAppFlowData(res[0].Flow_Builder_Object);
             //show App flow Builder
             setLoading(false);
      })
  }

  const handleShowConfirm = (data: any) => {
    setLoading(true);
    setConfirmData([]);
    handleOpenModal();    
    let payload = {
      Client_Id: ActiveClient.Client_Id,
      Env_Id: data.selectedEnv.Env_Id,
      Flow_Builder_Object: data.flowData,
      Insert_Data:data.updateDataList
    };
    updateConfirmation(payload, (res: any) => {
      if(res){
        setConfirmData(res.Data);
        setFlowSubmitData({...payload,data_summary:res.Data});
      }
      setLoading(false);
    });
  }
  



  const handleUpdateAppFlow = () => {
    setLoading(true);
    let payload = {
      Client_Id: ActiveClient.Client_Id,
      Env_Id: flowSubmitData.Env_Id,
      Flow_Builder_Object: flowSubmitData.Flow_Builder_Object,
      Insert_Data:flowSubmitData.Insert_Data,
      Data_Summary:flowSubmitData.data_summary
    };    
    updateFlow(payload, (res: any) => {
      if(res){
        alert(" Data updated successfully");
        handleCloseModal();
      }
      setLoading(false);
    });
  };










  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      {showFlowDiv && (

        <FlowBuilder
          load_Flow_Data={true}
          data={ActiveClient}
          flowRNData={appRNData}
          flowData={appFlowData}
          handleSubmitFlow={(data: any) => {
            handleShowConfirm(data);
          }}
          getFlowByEnv={(Env_Id: number) => {
            getFlowByEnv(Env_Id);
          }}
        />
      )}


    <ConfirmChangesModal 
        loading={loading}
        openConfirmModal={isModalOpen} 
        data={confirmData} 
        handleCloseModal={()=>{
          handleCloseModal();
        }}
        handleSubmit={(e)=>{
          handleUpdateAppFlow();
        }}
       />
    </>
  );
}

export default ApplicationFlow;
